import { triggerEdgeFunction } from 'utils';

import { isProductionBillingMode } from './stripePriceResolver';

export type BillingEdgeFunctionName =
  | 'cancel-subscription'
  | 'create-billing-portal'
  | 'create-checkout-session'
  | 'resume-subscription'
  | 'update-subscription';

const productionBillingFunctionMap: Record<BillingEdgeFunctionName, string> = {
  'cancel-subscription': 'cancel-subscription-prod',
  'create-billing-portal': 'create-billing-portal-prod',
  'create-checkout-session': 'create-checkout-session-prod',
  'resume-subscription': 'resume-subscription-prod',
  'update-subscription': 'update-subscription-prod',
};

export const resolveBillingFunctionName = (
  functionName: BillingEdgeFunctionName,
) => {
  if (!isProductionBillingMode()) {
    return functionName;
  }

  return productionBillingFunctionMap[functionName];
};

export const triggerBillingEdgeFunction = async <T>(
  functionName: BillingEdgeFunctionName,
  payload: T,
): Promise<{ data?: any; error?: string | null }> =>
  triggerEdgeFunction(resolveBillingFunctionName(functionName), payload);
